
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/marriott/internet-access/[index]",
      function () {
        return require("private-next-pages/marriott/internet-access/[index].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/marriott/internet-access/[index]"])
      });
    }
  